<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" row-key="Id"
      border lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" class="custom-tbl"
      style="width: 100%" ref="table">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Name" label="部门" width=""></el-table-column>
      <el-table-column prop="RealName" label="负责人" width=""></el-table-column>
      <el-table-column prop="Status" label="是否有效" width="">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status ? 'success' : 'danger'" disable-transitions>{{ !scope.row.Status ? "否" : "是"
            }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="" sortable>
      </el-table-column>
      <el-table-column prop="CreateBy" label="创建人" width="" sortable>
      </el-table-column>
      <el-table-column prop="ModifyTime" label="更新时间" :formatter="formatModifyTime" width="" sortable>
      </el-table-column>
      <el-table-column prop="ModifyBy" label="修改人" width="" sortable>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
        style="float: right"></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="部门名称" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级关系" prop="CodeRelationship">
          <el-tooltip placement="top">
            <div slot="content">以','号结尾，方便下属部门统一查询</div>
            <el-input v-model="editForm.CodeRelationship" disabled auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="负责人" prop="sysusers" label-width="">
          <el-select v-model="editForm.RealName" filterable placeholder="" @change="eidtorgchange" clearable>
            <el-option v-for="item in sysusers" :key="item.UId" :label="item.RealName" :value="item.UId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排序" prop="OrderSort">
          <el-input type="number" v-model="editForm.OrderSort" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否有效" prop="Status" width sortable>
          <el-switch v-model="editForm.Status"></el-switch>
        </el-form-item>
        <el-form-item prop="PidArr" v-if="options && options.length > 0" label="父级部门" width sortable>
          <el-cascader placeholder="请选择，支持搜索功能" style="width: 400px" v-model="editForm.PidArr" :options="options"
            filterable :key="isResouceShow" :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            v-if="!editLoading"></el-cascader>
          <el-cascader placeholder="加载中..." style="width: 400px" v-if="editLoading"></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="部门名称" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级关系" prop="CodeRelationship">
          <el-tooltip placement="top">
            <div slot="content">以','号结尾，方便下属部门统一查询</div>
            <el-input v-model="addForm.CodeRelationship" disabled auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="负责人" prop="sysusers" label-width="">
          <el-select v-model="addForm.sysusers" filterable placeholder="" @change="handleOrgChange" clearable>
            <el-option v-for="item in sysusers" :key="item.UId" :label="item.RealName" :value="item.UId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否有效" prop="Status" width sortable>
          <el-switch v-model="addForm.Status"></el-switch>
        </el-form-item>
        <el-form-item prop="PidArr" v-if="options && options.length > 0" label="父级部门" width sortable>
          <el-cascader placeholder="请选择，支持搜索功能" style="width: 400px" v-model="addForm.PidArr" :options="options"
            filterable :key="isResouceShow" :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            v-if="!editLoading"></el-cascader>
          <el-cascader placeholder="加载中..." style="width: 400px" v-if="editLoading"></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quxiao" @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getDepartmentTreeTable,
  removeDepartment,
  editDepartment,
  addDepartment,
  getDepartmentTree,
  getUsers,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data () {
    return {
      buttonList: [],
      currentRow: null,
      options: [],
      filters: {
        Name: "",
      },
      modules: [], //接口api列表
      statusList: [
        { Name: "激活", value: true },
        { Name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      mapstableTree: new Map(),
      tableTreeRefreshTool: {},
      users: [],
      sysusers: [],
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        PidArr: [{ required: true, message: "请选择父节点", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        sysusers: [],
        Id: 0,
        OrderSort: 0,
        PidArr: [],
        CreateBy: "",
        Name: "",
        CodeRelationship: "",
        Leader: "",
        Enabled: true,
        Status: false,
        UId: "",
        RealName: "",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        PidArr: [{ required: true, message: "请选择父节点", trigger: "blur" }],
        sysusers: [{ required: true, message: "请选择负责人", trigger: "change" }],
      },
      //新增界面数据
      addForm: {
        sysusers: null,
        CreateBy: "",
        CreateId: "",
        PidArr: [],
        OrderSort: 0,
        Name: "",
        CodeRelationship: "",
        Leader: "",
        Enabled: true,
        Status: true,
        UId: "",
        RealName: "",
      },
      isResouceShow: 0,
    };
  },
  methods: {
    dialogCheck (selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow (val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction (item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    formatModifyTime: function (row, column) {
      return !row.ModifyTime || row.ModifyTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.ModifyTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    handleCurrentChange (val) {
      this.page = val;
      this.handleQuery();
    },
    load (tree, treeNode, resolve) {
      //增删改的时候存储数据
      this.mapstableTree.set(tree.Id, { tree, treeNode, resolve })
      // 在之前声明的全局变量中，增加一个key为 本条数据的id，id可替换为你数据中的任意唯一值
      this.tableTreeRefreshTool[tree.Id] = {};
      //  重要！保存resolve方法，以便后续使用
      this.tableTreeRefreshTool[tree.Id].resolve = resolve;
      //  记录展开次数，具体作用后续介绍
      this.tableTreeRefreshTool[tree.Id].expandCount = 0;
      let para = {
        page: this.page,
        f: tree.Id,
        key: this.filters.Name,
      };
      getDepartmentTreeTable(para).then((res) => {
        resolve(res.data.response);
      });
    },
    //封装一个增删改刷新table数据的方法,组件懒加载数据的节点，data return的maps，及被操作节点的父节点
    refreshLoadTree (lazyTreeNodeMap, maps, parentId) {
      if (maps.get(parentId)) {
        const { tree, treeNode, resolve } = maps.get(parentId)
        this.$set(lazyTreeNodeMap, parentId, [])
        if (tree) { // 重新执行父节点加载子级操作
          this.load(tree, treeNode, resolve)
          if (tree.parentId) { // 若存在爷爷结点，则执行爷爷节点加载子级操作，防止最后一个子节点被删除后父节点不显示删除按钮
            const a = maps.get(tree.parentId)
            this.load(a.tree, a.treeNode, a.resolve)
          }
        }
      }
    },
    handleExpandChange (row, expanded) {
      console.log("点击展开", row, expanded);
      const curr = this.tableTreeRefreshTool[row.Id]

      // this.refreshLoadTree(this.$refs.table.store.states.lazyTreeNodeMap, this.mapstableTree, this.form.productId)
      curr.expandCount++
      // 如果是展开状态，且展开次数大于1，且上一次的状态为折叠，则请求api数据，更新子菜单
      if (expanded && curr.expandCount > 1 && !curr.prevStatus) {

        let para = {
          page: this.page,
          f: row.Id,
          key: this.filters.Name,
        };
        getPermissionTreeTable(para).then((res) => {
          curr.resolve(res.data.response);
        });
      }
      // 保存本次的展开或折叠状态，用于下次判断
      curr.prevStatus = expanded
    },
    //获取用户列表
    handleQuery () {
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;

      //NProgress.start();
      getDepartmentTreeTable(para).then((res) => {
        this.users = res.data.response;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    getusersQuery () {
      getUsers().then((res) => {
        if (res.data.success) {
          this.sysusers = res.data.response;
        }
      });
    },
    //删除
    handleDel () {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeDepartment(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              if (row.Pid != 0) {
                // 调用刷新展开的table
                this.refreshLoadTree(this.$refs.table.store.states.lazyTreeNodeMap, this.mapstableTree, row.Pid)
              }
              this.currentRow = null; // Clear current row selection
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit () {
      let row = this.currentRow;
      console.log(JSON.stringify(row) + "row");
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let that = this;
      this.getusersQuery();

      that.options = [];

      this.editForm = {};

      that.editLoading = true;
      that.editFormVisible = true;
      let para = { pid: row.Id };
      getDepartmentTree(para).then((res) => {
        ++that.isResouceShow;
        this.options.push(res.data.response);
        that.editForm = Object.assign({}, row);
        this.editForm.sysusers = this.sysusers;
        that.editLoading = false;
      });
    },
    //显示新增界面
    handleAdd () {
      this.options = [];
      this.addFormVisible = true;
      this.addLoading = true;
      this.addForm = {
        CreateBy: "",
        CreateId: "",
        PidArr: [],
        Name: "",
        CodeRelationship: "",
        OrderSort: 0,
        Leader: "",
        Enabled: true,
        Status: true,
        sysusers: null,
      };
      this.getusersQuery();
      let para = { pid: 0 };
      getDepartmentTree(para).then((res) => {
        ++this.isResouceShow;
        this.options.push(res.data.response);
        this.addLoading = false;
      });
    },
    handleOrgChange (value) {
      const selectedOrg = this.sysusers.find(item => item.UId === value);
      console.log(selectedOrg);
      if (selectedOrg) {
        this.addForm.UId = selectedOrg.UId;
        this.addForm.RealName = selectedOrg.RealName;
      }
    },
    eidtorgchange (value) {
      const selectedOrg = this.sysusers.find(item => item.UId === value);
      console.log(selectedOrg);
      if (selectedOrg) {
        this.editForm.UId = selectedOrg.UId;
        this.editForm.RealName = selectedOrg.RealName;
      }
    },
    //编辑
    editSubmit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.CodeRelationship = para.PidArr.join() + ",";

            para.ModifyTime = util.formatDate.format(
              new Date(),
              "yyyy-MM-dd hh:mm:ss"
            );

            para.Pid = para.PidArr.pop();

            if (para.Id == para.Pid) {
              this.$message({
                message: "警告，父节点不能是自己！",
                type: "error",
              });

              this.editLoading = false;
              return;
            }
            editDepartment(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              this.editLoading = false;
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                console.log("编辑部门");
                this.$refs["editForm"].resetFields();
                this.$refs.table.setCurrentRow();
                this.editFormVisible = false;
                this.handleQuery();

                if (para.Pid != 0) {
                  // 调用刷新展开的table
                  this.refreshLoadTree(this.$refs.table.store.states.lazyTreeNodeMap, this.mapstableTree, para.Pid)
                }
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.CodeRelationship = para.PidArr.join() + ",";

            para.CreateTime = util.formatDate.format(
              new Date(),
              "yyyy-MM-dd hh:mm:ss"
            );
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            para.Pid = para.PidArr.pop();

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addDepartment(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.$refs.table.setCurrentRow();
                this.addFormVisible = false;
                this.handleQuery();
                if (para.Pid != 0) {
                  // 调用刷新展开的table
                  this.refreshLoadTree(this.$refs.table.store.states.lazyTreeNodeMap, this.mapstableTree, para.Pid)
                }
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增页面取消
    quxiao () {
      this.$refs.addForm.resetFields();
      this.addForm.sysusers = null; // 或者设置为默认值
    }
  },
  mounted () {
    this.handleQuery();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
